
export const getFromLocalStorage = async (key) =>{

   return localStorage.getItem(key);

}